import ROUTES from '../../routes';
import {
    RegistrationFlowStep,
    registrationFlowSteps,
    STEP_PAYMENT_CONFIRMATION,
    STEP_PERSONAL,
    STEP_PHOTO_UPLOAD,
    STEP_PURCHASE,
    STEP_TEST_CENTER,
    STEP_TEST_CENTER_V2,
} from '../../constants/flowSteps';

// Place we send users when they have an invalid route, or the step number for the stepper doesn't match the route.
// TODO: possible we want to use the landing/dashboard page, instead of personal info for this.
const fallbackStepNumber = STEP_PERSONAL;
export const fallbackRoute = ROUTES.personalInfo;

/**
 * Based on route path, this method returns the stepNumber that matches with stepper
 * If there is no step number for the route, return the fallback step number.
 * @param  {string} routePath
 * @returns number
 */
export const getStepNumberForRoute = (routePath: string): number => {
    const locatedStep = registrationFlowSteps.find((step) => step.route === routePath);
    if (locatedStep === undefined) {
        return fallbackStepNumber;
    }

    return locatedStep.stepNumber;
};

/**
 * Given a step number, retrieve the data we have about the step.
 * @param stepNumber
 */
export const getStepByStepNumber = (stepNumber: number): RegistrationFlowStep | undefined => {
    return registrationFlowSteps.find((step) => step.stepNumber === stepNumber);
};

/**
 * Given the number of a step in the reg flow, return the matching route.
 * If no route is available for the given step, return the route for the personal info page.
 * TODO: redirect to landing page rather than personal info, once it's available.
 * @param stepNumber
 */
export const getRouteForStepNumber = (stepNumber: number): string => {
    const locatedStep = getStepByStepNumber(stepNumber);
    if (locatedStep === undefined) {
        return fallbackRoute;
    }

    return locatedStep.route;
};

/**
 * Given the internal step the user is on, return the step number that should be displayed.
 *
 * Two collapses happen here so the visible stepper matches VISIBLE_STEP_COUNT:
 *  - The new (STEP_TEST_CENTER_V2) and legacy (STEP_TEST_CENTER) test center steps are
 *    mutually exclusive and share a single displayed slot.
 *  - Payment and payment confirmation are tracked separately internally but shown as one step.
 *
 * Displayed slots: 0 Personal | 1 Test Center | 2 Photo | 3 Purchase.
 * @param stepNumber
 */
export const getDisplayStep = (stepNumber: number): number => {
    switch (stepNumber) {
        case STEP_PERSONAL:
            return 0;
        case STEP_TEST_CENTER_V2:
        case STEP_TEST_CENTER:
            return 1;
        case STEP_PHOTO_UPLOAD:
            return 2;
        case STEP_PURCHASE:
        case STEP_PAYMENT_CONFIRMATION:
            return 3;
        default:
            return stepNumber;
    }
};
